var _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4.33325,
    width: 25,
    height: 16.6667,
    rx: 2,
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.33325C1 6.44763 1 5.50482 1.58579 4.91904C2.17157 4.33325 3.11438 4.33325 5 4.33325H22C23.8856 4.33325 24.8284 4.33325 25.4142 4.91904C26 5.50482 26 6.44763 26 8.33325V8.7777H1V8.33325Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55566 1L6.55566 4.33333",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4443 1L20.4443 4.33333",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.55566,
    y: 11,
    width: 5.55556,
    height: 2.22222,
    rx: 0.5,
    fill: "#222222"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.55566,
    y: 15.4443,
    width: 5.55556,
    height: 2.22222,
    rx: 0.5,
    fill: "#222222"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8887,
    y: 11,
    width: 5.55556,
    height: 2.22222,
    rx: 0.5,
    fill: "#222222"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8887,
    y: 15.4443,
    width: 5.55556,
    height: 2.22222,
    rx: 0.5,
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.426c865112a264492777caba4115ed9f.svg";
export { ForwardRef as ReactComponent };